import { useHistory, useRouteMatch } from 'react-router';
import ErrorResponse from '../../../components/ErrorResponse';
import Loader from '../../../components/Loader';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import TypeEditor from '../../../components/cbt/type/Editor';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getTestType, putTestType } from '../../../api/testCenter.api';
import { IGetTestType, IPostTestTypeReq } from '../../../models/testCenter.model';

interface IMatch {
  id: string;
}

const CbtTypeEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const examTypeCode = Number(match.params.id);
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetTestType>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios<IGetTestType>();

  useEffect(() => {
    execute(getTestType(examTypeCode));
  }, []);

  useEffect(() => {
    if (submitRes) {
      successNotification(t('common.message.edit1'));
      history.push(`/cbt/type?eduStepCode=${submitRes?.data?.eduStepCode}`);
    }
  }, [submitRes]);

  const onSubmit = (req: IPostTestTypeReq) => {
    submitExecute(putTestType(examTypeCode, req));
  };

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        parentMenu={t('common.menu.cbt')}
        currentMenu={t('cbt.type.1')}
        onlyTitle
      />

      <TypeEditor
        type={res?.data}
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default CbtTypeEdit;
